<template>
	<div ref="wmsg" class="welcome-msg">
		<img class="hi" src="../image/icon-hi.png" />
		<div class="msg" v-html="current.content"></div>
	</div>
</template>
<script>
import gsap from "gsap";

export default {
	props: {
		msgs: {
			type: Array,
			default: [], // WSocketMessage[]
		},
	},
	components: {},
	data() {
		return {
			tl: null,
			messages: [],
			current: {},
			el: null,
		};
	},
	computed: {},
	watch: {
		msgs(newV, oldV) {
			this.messages.push(...newV);
			if (!this.current.content) {
				this.$nextTick(() => this.show());
			}
		},
	},
	mounted() {
		this.el = this.$refs.wmsg;
		this.tl = gsap.timeline();
		gsap.set(this.$refs.wmsg, { x: -500 });
	},
	beforeDestroy() {
		this.tl?.kill();
		this.messages = [];
		this.current = {};
	},
	methods: {
		show() {
			this.current = this.messages.shift() || {};
			if (!this.current.content) {
				console.log("Bubble 数据已清空");
				return;
			}
			
			this.$nextTick(() => {
				this.tl.clear();
				setTimeout(() => {
					const width = this.el.offsetWidth;

					console.log('width',width)
					this.tl
						.fromTo(
							this.el,
							{
								x: -width,
								opacity: 1,
							},
							{
								duration: 0.3,
								x: 0,
							}
						)
						.to(this.el, {
							duration: 0.3,
							x: -width - 10,
							delay: 2,
							onComplete: () => {
								this.$nextTick(() => this.show());
							},
						});

				}, 300);
				
			});
		},
	},
};
</script>
<style lang="less" scoped>
@import "../chat.less";
.welcome-msg {
	.flex-r-start-c-center;
	width: max-content;
	height: 25px;
	padding: 5px 15px 5px 10px;
	border-radius: 0 25px 25px 0;
	background-color: @text-bg-1;
	.hi {
		width: 12px;
		height: 12px;
	}
	.msg {
		margin-left: 6px;
		font-weight: bold;
		span {
			color: #1e54d5;
			margin: 0 5px;
		}
	}
}
</style>
